module.exports = __webpack_public_path__ + "img/icon-data06.174c6827.png";